import { atom } from "recoil";
const imagesAtom = atom<any>({
    key: 'imagesState',
  default: [],
})
export {imagesAtom}